module.exports = __webpack_public_path__ + "static/media/presse02.a4ae73a3.png";